// extracted by mini-css-extract-plugin
export default {"root":"ImageCard_root__XCFyz"};